<template>
  <img :src="src">
</template>

<script>

const defaultSrc = require('@/assets/user_default.png')

export default {
  name: 'UserPhoto',

  props: {
    name: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      src: defaultSrc
    }
  },

  watch: {
    name: {
      immediate: true,
      handler() {
        const userSrc = `http://tpp.tmeoa.com/photo/48/${this.name}.png`
        let img = new Image()
        img.src = userSrc

        img.onload = () => {
          this.src = userSrc
          img = null
        }
        img.onerror = () => {
          this.src = defaultSrc
          img = null
        }
      }
    }
  }
}
</script>

<style scoped>
img {
  border-radius: 50%;
}
</style>
